import BaseRepository from "~/repositories/BaseRepository";
import ArticleModel from "~/models/ArticleModel";

export default class ArticleSearchRepository extends BaseRepository {
  async index(params = {}, offset = 0, limit = 10): Promise<any> { // eslint-disable-line @typescript-eslint/no-explicit-any
    // MEMO: queryパラメータにjson文字列を入れる形式のインターフェースになっている
    const searchParams = {
      limit: limit,
      offset: offset,
      article: JSON.stringify(params)
    };
    const url = "/api/v1/article_searches";
    const results = await this._get(url, searchParams);
    return results.data.map(data => new ArticleModel(data));
  }
}
